import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Progress } from './ui/progress';

interface ChakraData {
  name: string;
  color: string;
  balance: number;
  icon: string;
}

export function ChakraBalanceChart() {
  const chakras: ChakraData[] = [
    { name: 'Root', color: 'bg-red-500', balance: 85, icon: 'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947007748_269a2af9.webp' },
    { name: 'Sacral', color: 'bg-orange-500', balance: 72, icon: 'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947009477_da8009dc.webp' },
    { name: 'Solar Plexus', color: 'bg-yellow-500', balance: 90, icon: 'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947011222_e4552c3b.webp' },
    { name: 'Heart', color: 'bg-green-500', balance: 95, icon: 'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947012974_574f7d39.webp' },
    { name: 'Throat', color: 'bg-blue-500', balance: 78, icon: 'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947014695_96c8d44a.webp' },
    { name: 'Third Eye', color: 'bg-indigo-500', balance: 88, icon: 'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947016499_e4a21025.webp' },
    { name: 'Crown', color: 'bg-purple-500', balance: 92, icon: 'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947018263_118aa2a0.webp' }
  ];

  return (
    <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-purple-500/30">
      <CardHeader>
        <CardTitle className="text-purple-200">Chakra Balance</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {chakras.map((chakra) => (
            <div key={chakra.name} className="flex items-center space-x-4">
              <img src={chakra.icon} alt={chakra.name} className="w-8 h-8 opacity-80" />
              <div className="flex-1">
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-purple-200">{chakra.name}</span>
                  <span className="text-white font-medium">{chakra.balance}%</span>
                </div>
                <Progress value={chakra.balance} className="h-2" />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}